import React from "react" ;

import ScrollRails from "../../Common/Body/ScrollRails";
import TeamAppBodyHeader from "./TeamAppBodyHeader";
import {Route, Switch} from "react-router-dom";
import {
    getTeamRouterPath,
    PATH_TEAM_ROOT,
    PATH_TEAM_USER_CONNECTION,
    PATH_TEAM_USER_DASHBOARD
} from "root/Wieldy/routePaths";
import TeamMembersTab from "./TeamMembers/TeamMembersTab";
import TeamDashboardTab from "./TeamDashboards/TeamDashboardTab";
import TeamInfoForm from "root/Wieldy/ApplicationModules/Team/Body/TeamDetails/TeamInfoForm";
import ConnectionsTab from "root/Wieldy/ApplicationModules/Child/Body/ChildConnections/ConnectionsTab";
import UsersDashboardTab from "root/Wieldy/ApplicationModules/Users/Body/UserDashboards/UsersDashboardTab";

const TeamAppBody= (props) =>
{
    return (
    <div className="dt-module__container">

        <TeamAppBodyHeader team_id={props.team_id}/>

        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>

            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_TEAM_USER_CONNECTION} render={(thisprops) => <ConnectionsTab {...thisprops}/>}/>
                        <Route path={PATH_TEAM_USER_DASHBOARD} render={(thisprops) => <UsersDashboardTab {...thisprops}/>}/>
                        <Route path={getTeamRouterPath('users/:user_type?')} render={(thisprops) => <TeamMembersTab {...thisprops}/>}/>
                        <Route path={getTeamRouterPath('details')} render={(thisprops) => <TeamInfoForm team_id={props.team_id } {...thisprops}/>}/>
                        <Route path={getTeamRouterPath('dashboard')} render={(thisprops) => <TeamDashboardTab team_id={props.team_id } {...thisprops}/>}/>
                        <Route path={PATH_TEAM_ROOT} render={(thisprops) => <TeamMembersTab team_id={props.team_id } {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>

            <ScrollRails />

        </div>
    </div>
    ) ;
}

export default TeamAppBody;
